import { Box, IconButton, type SpeedDialActionProps, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "app/redux-store-interactions";
import { SpeedDialAction } from "components";
import { featuresConfig } from "config/features";
import { CameraSpeedLevel, renderActions, selectCurrentCameraSpeedLevel } from "features/render";
import RunIcon from "media/icons/run.svg?react";
import SprintIcon from "media/icons/sprint.svg?react";
import WalkIcon from "media/icons/walk.svg?react";

type Props = SpeedDialActionProps & {
    position?: { top?: number; right?: number; bottom?: number; left?: number };
    newDesign?: boolean;
};

export function CameraSpeed({ position, newDesign, ...speedDialProps }: Props) {
    const { nameKey } = featuresConfig["cameraSpeed"];
    const { t } = useTranslation();
    const speed = useAppSelector(selectCurrentCameraSpeedLevel);

    const dispatch = useAppDispatch();

    const handleClick = () => dispatch(renderActions.toggleCameraSpeed());

    const Icon = speed === CameraSpeedLevel.Slow ? WalkIcon : speed === CameraSpeedLevel.Default ? RunIcon : SprintIcon;
    const tooltipTitle = `${t(nameKey)} - ${t(speed)}`;

    if (newDesign) {
        return (
            <Tooltip title={tooltipTitle} placement="top">
                <Box>
                    <IconButton onClick={handleClick}>
                        <Icon />
                    </IconButton>
                </Box>
            </Tooltip>
        );
    }

    return (
        <SpeedDialAction
            {...speedDialProps}
            data-test="camera-speed"
            FabProps={{ ...speedDialProps.FabProps, style: { ...position, position: "absolute" } }}
            onClick={handleClick}
            title={tooltipTitle}
            icon={<Icon />}
        />
    );
}
